import Link from 'next/link';
import React from 'react';

type StepProps = {
  stepNumber: number;
  label: string;
  isCompleted: boolean;
  href: string | null;
}

const BookingFlowStep: React.FC<StepProps> = ({
  stepNumber,
  label,
  isCompleted,
  href,
}) => {
  const classes = `${isCompleted ? 'bg-primary text-white ' : 'bg-transparent text-primary '} w-10 h-10 rounded-full flex items-center justify-center font-bold text-2xl border-2 border-solid border-primary mb-2`;

  const content = (
    <div
      className="flex items-center flex-col min-w-20"
    >
      <div
        className={classes}
      >
        {stepNumber}
      </div>
      <span className="text-md text-center uppercase text-primary">{label}</span>
    </div>
  );

  return href ? (
    <Link
      href={href}
    >
      {content}
    </Link>
  ) : content;
};

export default BookingFlowStep;

